module.exports = new __parcel__URL__("focusedregeneration.9e699438.png").toString();